var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    { staticStyle: { width: "100%" }, attrs: { data: _vm.requests } },
    [
      _c("el-table-column", { attrs: { prop: "uuid", label: "ID" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "device_id", label: "Device ID" },
      }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "type", label: "type" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "state", label: "State" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "agent", label: "Agent" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "created_at", label: "Date" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "comment", label: "Comment" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }